'use strict';

import {Endpoint} from "../Endpoint.js";

export class Currencies extends Endpoint {
	constructor() {
		super();
	}

	async fetchData() {
		const endpoint = '/wp-json/levcharity/v1/currencies';
		try {
			return await this.fetch(endpoint);
		} catch (error) {
			console.error('Error fetching settings:', error.message);
		}
	}
}
